import { CardModel, PileCardModel } from "../../interface/game";
import { PileAnnotationPolicy } from "./pile-annotation-policy";

export function pileTopOnlyDragPolicy(): PileAnnotationPolicy {
    return (pile: PileCardModel[], cards: {[key: string]: CardModel}): PileCardModel[] =>
        [
            ...pile.slice(0, -1).map((card) => ({...card, draggable: false})),
            ...pile.slice(-1).map((card) => ({...card, draggable: true}))
        ];
}